webpackJsonp([114],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_util__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(342);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */],
  mode: 'history'
});

router.beforeEach(function (to, from, next) {
  if (to.path != '/login' && !localStorage.getItem('token')) {
    router.push({ name: "login" });
  }
  next();
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__libs_util__["a" /* default */].title(to.meta.title);
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_easemob_websdk__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_easemob_websdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_easemob_websdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_easemob_webrtc__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_easemob_webrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_easemob_webrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WebIMConfig__ = __webpack_require__(330);







function ack(message) {
	var bodyId = message.id;
	var msg = new WebIM.message("read", WebIM.conn.getUniqueId());
	msg.set({
		id: bodyId,
		to: message.from
	});
	WebIM.conn.send(msg.body);
}
var WebIM = {};

WebIM = window.WebIM = __WEBPACK_IMPORTED_MODULE_2_easemob_websdk___default.a;
WebIM.config = __WEBPACK_IMPORTED_MODULE_4__WebIMConfig__["a" /* default */];
WebIM.conn = new WebIM.connection({
	appKey: WebIM.config.appkey,
	isHttpDNS: WebIM.config.isHttpDNS,
	isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
	https: WebIM.config.https,
	url: WebIM.config.xmppURL,
	apiUrl: WebIM.config.apiURL,
	isAutoLogin: true,
	heartBeatWait: WebIM.config.heartBeatWait,
	autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
	autoReconnectInterval: WebIM.config.autoReconnectInterval,
	isStropheLog: WebIM.config.isStropheLog,
	delivery: WebIM.config.delivery
});
if (!WebIM.conn.apiUrl) {
	WebIM.conn.apiUrl = WebIM.config.apiURL;
}
if (localStorage.getItem('webIm') != 'err' && localStorage.getItem('webIm')) {
	onLoginWebIm();
}

function onLoginWebIm() {
	var data = JSON.parse(localStorage.getItem('principal'));
	WebIM.conn.open({
		apiUrl: WebIM.config.apiURL,
		user: data.id,
		pwd: data.id.slice(1, -1),
		appKey: WebIM.config.appkey,
		success: function success(re) {
			localStorage.setItem('webIm', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(re));
			console.log('登陆成功');
		},
		error: function error(err) {
			localStorage.setItem('webIm', 'err');
		}
	});
}

WebIM.conn.listen({
	onOpened: function onOpened(message) {
		console.log("onOpened", message);
	},
	onError: function onError(message) {
		console.log("onError", message);
	},
	onClosed: function onClosed(message) {
		console.log("onClosed", message);
	},
	onOffline: function onOffline() {
		console.log("onOffline");
	},
	onTextMessage: function onTextMessage(message) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageMid", message);
		console.log("onTextMessage", message);
	},
	onEmojiMessage: function onEmojiMessage(message) {
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageMid", message);
		console.log("onEmojiMessage", message);
	},
	onPictureMessage: function onPictureMessage(message) {
		console.log("onPictureMessage", message);
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageMid", message);
	},
	onAudioMessage: function onAudioMessage(message) {
		console.log("onAudioMessage", message);
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageMid", message);
	},
	onFileMessage: function onFileMessage(message) {
		console.log("onFileMessage", message);
	},
	onVideoMessage: function onVideoMessage(message) {
		console.log("onVideoMessage", message);
	},
	onReceivedMessage: function onReceivedMessage(message) {
		console.log("onReceivedMessage", message);

		message.status = "sent";
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageStatus", message);
	},
	onDeliveredMessage: function onDeliveredMessage(message) {
		console.log("onDeliveredMessage", message);
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('updateMessageStatus', message);
	},
	onReadMessage: function onReadMessage(message) {
		console.log("onReadMessage", message);
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateMessageStatus", message);
	} });

WebIM.WebRTC = __WEBPACK_IMPORTED_MODULE_3_easemob_webrtc___default.a;

WebIM.EMedia = __WEBPACK_IMPORTED_MODULE_3_easemob_webrtc___default.a.emedia;

/* harmony default export */ __webpack_exports__["a"] = (WebIM);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__advisory__ = __webpack_require__(345);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_2__advisory__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {};

util.title = function (title) {
    title = title ? title + ' - 明我视力管理后台' : '明我视力管理后台';
    window.document.title = title;
};

util.priceUtils = function (price) {
    var json = {
        price: price
    };
    var startIndex = json.price.indexOf(".");
    if (startIndex == -1) {
        json.price = (price + '00') * 1;
    } else {
        var yuan = json.price.substring(0, startIndex);
        var fen = json.price.substring(startIndex + 1, json.price.length);
        if (fen.length == 1) {
            fen += "0";
        }
        json.price = (yuan + fen) * 1;
    }
    return json.price;
};

util.showWeekFirstDay = function () {
    var Nowdate = new Date();
    var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
    var M = Number(WeekFirstDay.getMonth()) + 1;
    var MM = M > 10 ? M : '0' + M;
    var d = WeekFirstDay.getDate();
    var dd = d > 10 ? d : '0' + d;
    return WeekFirstDay.getFullYear() + "-" + MM + "-" + dd + " 00:00:00";
};

util.showWeekLastDay = function () {
    var Nowdate = new Date();
    var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
    var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
    var M = Number(WeekLastDay.getMonth()) + 1;
    var MM = M > 10 ? M : '0' + M;
    var d = WeekLastDay.getDate();
    var dd = d > 10 ? d : '0' + d;
    return WeekLastDay.getFullYear() + "-" + MM + "-" + dd + " 23:59:59";
};
util.currentMonth = function () {
    var Nowdate = new Date();
    var yy = Nowdate.getFullYear();
    var MonthFirstDay = new Date(Nowdate.getFullYear(), Nowdate.getMonth(), 1);
    var M = Number(MonthFirstDay.getMonth()) + 1;
    var MM = M > 10 ? M : '0' + M;
    var s_d = MonthFirstDay.getDate() > 10 ? MonthFirstDay.getDate() : '0' + MonthFirstDay.getDate();
    var e_d = Nowdate.getDate() > 10 ? Nowdate.getDate() : '0' + Nowdate.getDate();
    return {
        start: yy + '-' + MM + '-' + s_d + ' 00:00:00',
        end: yy + '-' + MM + '-' + e_d + ' 23:59:59'
    };
};

util.getDaysBetween = function (dateString1, dateString2) {
    var star = util.formatTimestamp(dateString1, "yyyy-MM-dd");
    var end = util.formatTimestamp(dateString2, "yyyy-MM-dd");
    var startDate = Date.parse(star);
    var endDate = Date.parse(end);

    var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    return days;
};

util.formatTimestamp = function (timestamp, format) {
    if (!timestamp) return;
    return util.formatDate(new Date(timestamp), format);
};

util.formatDate = function (date, format) {
    if (!date || !(date instanceof Date)) {
        return date;
    }
    var formatted = format || 'yyyy-MM-dd hh:mm:ss';

    var map = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() };
    if (/(y+)/.test(formatted)) {
        var value = date.getFullYear().toString().substr(4 - RegExp.$1.length);
        formatted = formatted.replace(RegExp.$1, value);
    }
    for (var key in map) {
        if (new RegExp("(" + key + ")").test(formatted)) {
            var _value = map[key].toString();
            if (RegExp.$1.length != 1) {
                _value = ("00" + _value).substr(_value.length);
            }
            formatted = formatted.replace(RegExp.$1, _value);
        }
    }
    return formatted;
};
util.validateEmptys = function (rule, value, callback, msg) {
    if (value.replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '') == '') {
        callback(new Error(msg));
    } else {
        callback();
    }
};
var vcity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏",
    33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南",
    42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆",
    51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃",
    63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
};
util.validateCard = function (rule, value, callback) {
    if (!util.checkCard(value)) {
        callback(new Error('身份证输入有误，请重新输入!'));
    } else {
        callback();
    }
};
util.checkCard = function (obj) {
    if (util.isCardNo(obj) === false) {
        return false;
    }

    if (util.checkProvince(obj) === false) {
        return false;
    }

    if (util.checkBirthday(obj) === false) {
        return false;
    }

    if (util.checkParity(obj) === false) {
        return false;
    }
    return true;
};

util.isCardNo = function (obj) {
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)|(^\d{17}(\d|x)$)/;
    if (reg.test(obj) === false) {
        return false;
    }
    return true;
};

util.checkProvince = function (obj) {
    var province = obj.substr(0, 2);
    if (vcity[province] == undefined) {
        return false;
    }
    return true;
};

util.checkBirthday = function (obj) {
    var len = obj.length;

    if (len == '15') {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        var arr_data = obj.match(re_fifteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date('19' + year + '/' + month + '/' + day);
        return util.verifyBirthday('19' + year, month, day, birthday);
    }

    if (len == '18') {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})(([0-9]|X)|([0-9]|x))$/;
        var arr_data = obj.match(re_eighteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date(year + '/' + month + '/' + day);
        return util.verifyBirthday(year, month, day, birthday);
    }
    return false;
};

util.verifyBirthday = function (year, month, day, birthday) {
    var now = new Date();
    var now_year = now.getFullYear();

    if (birthday.getFullYear() == year && birthday.getMonth() + 1 == month && birthday.getDate() == day) {
        var time = now_year - year;
        if (time >= 0 && time <= 130) {
            var birthday_ = year + "-" + month + "-" + day;
            return true;
        }
        return false;
    }
    return false;
};

util.checkParity = function (obj) {
    obj = util.changeFivteenToEighteen(obj);
    var len = obj.length;
    if (len == '18') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0,
            i,
            valnum;
        for (i = 0; i < 17; i++) {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[cardTemp % 11];
        if (valnum == obj.substr(17, 1)) {
            return true;
        }
        return false;
    }
    return false;
};

util.changeFivteenToEighteen = function (obj) {
    if (obj.length == '15') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0,
            i;
        obj = obj.substr(0, 6) + '19' + obj.substr(6, obj.length - 6);
        for (i = 0; i < 17; i++) {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        obj += arrCh[cardTemp % 11];
        return obj;
    }
    return obj;
};

util.numAdd = function (a, b) {
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (util.mul(a, e) + util.mul(b, e)) / e;
};
util.sub = function (a, b) {
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (util.mul(a, e) - util.mul(b, e)) / e;
};
util.accMul = function (a, b) {
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
};
util.mul = function (a, b) {
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
};

util.except = function (a, b) {
    var c,
        d,
        e = 0,
        f = 0;
    try {
        e = a.toString().split(".")[1].length;
    } catch (g) {}
    try {
        f = b.toString().split(".")[1].length;
    } catch (g) {}
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), util.mul(c / d, Math.pow(10, f - e));
};

util.isMobile = function (str) {
    return (/^(([1][3,4,5,6,7,8,9][0-9]{9})|(853[0-9]{8})|(886[0-9]{8})|(852[0-9]{8}))$/.test(str)
    );
};

util.isTel = function (str) {
    return (/^0\d{3,4}-?\d{7,8}$/.test(str)
    );
};

util.isPassWord = function (str) {
    return (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/.test(str)
    );
};

util.isUrl = function (str) {
    return (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/.test(str)
    );
};

util.genderChange = function (val) {
    var list = { 'LADY': '女', 'MAN': '男', 'UNKNOWN': '未知', 'nul': '--' };
    return list[val];
};
util.offsetTop = function (el) {
    var top = null;
    var elPar = el ? el.offsetParent : 0;
    top += el ? el.offsetTop : 0;
    while (elPar) {
        if (navigator.userAgent.indexOf("MSIE 8.0") == -1) {
                top += elPar.clientTop;
            }
        top += elPar.offsetTop;
        elPar = elPar.offsetParent;
    }
    return top;
};

/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81ec5858",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(106);






var servers = {
    dev: 'http://localhost:9630/',
    prod: 'https://mwslapi.mingwo.cn/'
};

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    timeout: 30000,
    baseURL: typeof environment == 'undefined' ? servers['prod'] : servers[environment]
});

http.interceptors.request.use(function (config) {
    var token = localStorage.getItem("token");
    if (token) {
        var loginTime = localStorage.getItem("loginTime");
        var nowTime = new Date().getTime();
        if (nowTime - loginTime >= 2880 * 60 * 1000) {
            localStorage.removeItem("token");
            config.headers.sskey = "";
            __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].push({ name: 'login' });
        } else {
            loginTime = nowTime;
            localStorage.setItem("loginTime", loginTime);
            config.headers.sskey = token;
        }
    }
    return config;
}, function (error) {
    console.error(error);
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

http.interceptors.response.use(function (response) {
    var result = imgUrlReplace(response.data);
    if (response.status == 200) {
        return result;
    } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result);
    }
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
        status: "CLIENT_ERROR",
        message: error.message
    });
});

/* harmony default export */ __webpack_exports__["a"] = ({

    install: function install(Vue) {
        Vue.prototype.$http = http;
    }
});

function imgUrlReplace(row) {
    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row);
    data = data.replace(/coffer.bainuo.cn/ig, 'coffer.mingwo.cn');
    data = data.replace(/coffer-cdn.bainuo.cn/ig, 'coffer.mingwo.cn');
    return JSON.parse(data);
}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-807f5646",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);



var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var devUser = {
  logged: true,
  profile: {
    name: "bainuo"
  }
};

var emptyUser = {
  logged: false,

  profile: null
};

/* unused harmony default export */ var _unused_webpack_default_export = ( false ? devUser : emptyUser);

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_bus__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_user__ = __webpack_require__(300);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'APP',
    created: function created() {
        var _this = this;

        var token = localStorage.getItem("token");
        __WEBPACK_IMPORTED_MODULE_0__libs_bus__["a" /* default */].$on('logout', function () {
            localStorage.clear();
            sessionStorage.clear();
            _this.$router.push({
                name: 'login'
            });
        });
    }

});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "GenericForm",
    props: {
        model: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: "编辑页面"
        },
        labelWidth: {
            type: Number,
            default: 110
        },
        resetShow: {
            type: Boolean,
            default: true
        },
        submitBtnTxt: {
            type: String,
            default: "提交"
        }
    },
    data: function data() {
        return {
            data: {}
        };
    },

    methods: {
        submitEditForm: function submitEditForm() {
            var _this = this;

            this.$refs.form.validate(function (valid) {
                if (!valid) {
                    _this.$Message.warning('你有内容还未填写完成,请继续填写');
                    return;
                };
                _this.$emit('submit', _this.model);
            });
        }
    }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loading',
  props: ['loading'],
  computed: {
    _loading: function _loading() {
      return this.loading;
    }
  },
  data: function data() {
    return {
      heights: ''
    };
  },
  created: function created() {
    this.heights = "height:" + document.body.clientHeight + "px";
  },
  watch: {
    loading: function loading() {}
  }

});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(37);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ModalForm",
    props: {
        modeWidth: {
            type: String,
            default: "520"
        },
        textStyle: {
            type: String,
            default: "text-align: right;"
        },
        showFooterBtn: {
            type: Boolean,
            default: true
        },
        labelWidth: {
            type: Number,
            default: 100
        }
    },
    data: function data() {
        return {
            show: false,
            enable: false,
            title: '请按照提示输入',
            model: {},
            rules: {},
            submitter: null
        };
    },
    methods: {
        showForm: function showForm(options) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this, options);
            this.enable = true;
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
                _this.show = true;
            });
        },
        validate: function validate() {
            this.$refs.form.validate(function (valid) {
                console.debug("\u8868\u5355\u9A8C\u8BC1" + (valid ? '通过' : '不通过'));
            });
        },
        submitForm: function submitForm() {
            var _this2 = this;

            this.$refs.form.validate(function (valid) {
                if (!valid || !_this2.submitter) return;


                var $model = _this2.deleteProperties(_this2.model, ['_index', '_rowKey']);
                _this2.submitter($model).then(function (result) {
                    _this2.show = false;
                    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
                        _this2.enable = false;
                        _this2.$Notice.success({
                            title: '提交成功'
                        });
                    });
                }).catch(function (error) {
                    _this2.$Notice.error({
                        title: '提交失败',
                        desc: error.message
                    });
                });
            });
        },
        deleteProperties: function deleteProperties(source, props) {
            var target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, source);
            var $props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(target);
            props.forEach(function (prop) {
                if ($props.some(function (p) {
                    return p === prop;
                })) {
                    delete target[prop];
                }
            });
            return target;
        }
    }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PagedList__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PagedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PagedList__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ModalSelect",
    props: {
        api: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ""
        },

        title: {
            type: String,
            default: '请选择'
        },

        columns: {
            type: Array,
            required: true
        },

        params: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            show: false,
            enable: false,
            loading: true,

            total: 0,
            list: [],
            page: {
                page: 1,
                size: 10
            },
            model: {}
        };
    },
    methods: {
        showModal: function showModal() {
            var _this = this;

            this.enable = true;
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
                _this.show = true;
                _this.submitForm();
            });
        },
        dblclickRow: function dblclickRow(row) {
            var _this2 = this;

            this.show = false;
            this.$emit('selected', row);
            setTimeout(function () {
                _this2.enable = false;
            }, 1000);
        },
        changePage: function changePage(page) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, page);
            this.submitSearchParams();
        },
        submitForm: function submitForm() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, { page: 1 });
            this.submitSearchParams();
        },
        submitSearchParams: function submitSearchParams() {
            var _this3 = this;

            this.loading = true;
            this.$http.get(this.api, {
                params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, this.page, this.model)
            }).then(function (result) {
                _this3.loading = false;
                _this3.list = result.list;
                _this3.total = result.totalElements;
            }).catch(function (error) {
                _this3.list = [];
                _this3.loading = false;
                _this3.$Message.error("错误：" + error.message);
            });
        }
    },
    components: { PagedList: __WEBPACK_IMPORTED_MODULE_2__components_PagedList___default.a }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "PagedList",

    props: {
        loading: {
            type: Boolean,
            default: true
        },

        footerShow: {
            type: Boolean,
            default: false
        },
        highlight: {
            type: Boolean,
            default: false
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        stripe: {
            type: Boolean,
            default: true
        },

        pageList: {
            type: Boolean,
            default: true
        },
        pageSize: {
            type: Array,
            default: function _default() {
                return [10, 20, 50, 100, 400];
            }
        },
        total: {
            type: Number,
            default: 0
        },

        page: {
            type: Object,
            default: function _default() {
                return {
                    page: 1,
                    size: 10
                };
            }
        },

        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        },

        columns: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        pageFloat: {
            type: String,
            default: 'float: right;'
        }
    },
    methods: {
        onChangePage: function onChangePage(newPage) {
            this.$emit("changePage", {
                page: newPage,
                size: this.page.size
            });
        },
        onChangePageSize: function onChangePageSize(newSize) {
            this.$emit("changePage", {
                size: newSize,
                page: this.page.page
            }, "newSize");
        },
        onclickRow: function onclickRow(row) {
            this.$emit('clickRow', row);
        },
        onChangeSelection: function onChangeSelection(selection) {
            this.$emit('changeSelection', selection);
        },
        sortCange: function sortCange(row) {
            this.$emit('onSortCange', row);
        }
    }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagedList__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PagedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_util_js__ = __webpack_require__(160);











function castToTypedValue(value, key) {
    if (typeof value !== 'string' || !value.length) {
        return value;
    }

    if (value === 'true' || value === 'false') {
        return value === 'true';
    }

    if (isNaN(value)) {
        return value;
    } else {
        if (key == 'expiredDays') {
            return value;
        } else {
            if (value.indexOf('.') === -1) {
                if (value.length < 16 && value != ' ' && !/^0/.test(value)) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(value);
                } else {
                    return value;
                }
            } else {
                if (value.length < 16 && value != ' ' && !/^0(?!\.)/.test(value)) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(value);
                } else {
                    return value;
                }
            }
        }
    }
}

function parseParamsFromQuery(query) {
    if (!query) return query;
    var params = {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(query).forEach(function (prop) {
        var value = query[prop];
        params[prop] = castToTypedValue(value, prop);
    });
    return params;
}

function filterProps(source, filter) {
    if (!source) return source;

    var target = {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(source).filter(filter).filter(function (prop) {
        return prop !== '__ob__';
    }).forEach(function (prop) {
        target[prop] = source[prop];
    });
    return target;
}

function restorePage(target, source) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target, filterProps(source, function (prop) {
        return ['page', 'size'].indexOf(prop) !== -1;
    }));
}

function restoreModel(target, source) {
    var temp = filterProps(source, function (prop) {
        return ['page', 'size'].indexOf(prop) === -1;
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target, temp);
    var targetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(temp);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(target).forEach(function (prop) {
        if (targetProps.indexOf(prop) === -1 && prop !== '__ob__') {
            target[prop] = undefined;
        }
    });
}

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "UserManager",
    props: {
        api: {
            type: String,
            required: true
        },

        pageList: {
            type: Boolean,
            default: true
        },

        model: {
            type: Object,
            required: true
        },

        modalWrap: {
            type: Boolean,
            default: true
        },

        columns: {
            type: Array,
            default: function _default() {
                return [];
            }
        },

        bindWithRoute: {
            type: Boolean,
            default: true
        },

        showQueryBtn: {
            default: true,
            type: Boolean
        },

        showReseBtn: {
            default: true,
            type: Boolean
        },

        highlight: {
            default: false,
            type: Boolean
        },

        showHeader: {
            default: true,
            type: Boolean
        },

        stripe: {
            default: true,
            type: Boolean
        },
        floatDom: {
            type: String,
            default: 'float:right'
        },

        responseFn: {
            type: Function
        },
        pageFloat: {
            type: String,
            default: 'float: right;'
        },
        pageSize: {
            type: Array,
            default: function _default() {
                return [10, 20, 50, 100, 400];
            }
        },
        page: {
            type: Object,
            default: function _default() {
                return {
                    page: 1,
                    size: 10
                };
            }
        }
    },
    data: function data() {
        return {
            total: 0,
            list: [],
            loading: true,

            originModel: null
        };
    },
    created: function created() {

        this.originModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model);
        if (this.bindWithRoute) {
            var query = this.$route.query;
            var params = parseParamsFromQuery(query);
            if (params.size) this.page.size = params.size;
        }
    },
    mounted: function mounted() {
        this.forceReload();
    },

    watch: {
        $route: function $route() {
            this.forceReload();
        }
    },
    methods: {
        forceReload: function forceReload() {
            if (this.bindWithRoute) {
                var query = this.$route.query;
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(query).length) {
                    var params = parseParamsFromQuery(query);
                    restorePage(this.page, params);
                    restoreModel(this.model, params);
                    this.fetchData(params);
                } else {
                    restoreModel(this.model, this.originModel);
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, { page: 1, size: this.page.size });
                    this.fetchData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.page, this.model));
                }
            } else {
                var _params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ page: 1, size: this.page.size }, this.page, this.model);
                this.fetchData(_params);
            }
        },
        changePage: function changePage(page, prod) {
            if (prod == "newSize") page.page = 1;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, page);
            this.submitSearchParams();
        },
        onChangeSelection: function onChangeSelection(selection) {
            this.$emit('changeSelection', selection, this.list);
        },
        onclickRow: function onclickRow(selection) {
            this.$emit('clickRow', selection, this.list);
        },
        onSortCange: function onSortCange(row) {
            this.$emit('onSortCange', row);
        },
        submitForm: function submitForm(reset) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, { page: 1 });
            this.submitSearchParams(reset);
        },
        submitSearchParams: function submitSearchParams(reset) {
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model, this.page);
            if (reset && params.nameOrNum != undefined) {
                params.nameOrNum = '';
            }
            if (params.settlementPeriod != undefined && params.settlementPeriod) {
                params.settlementPeriod = __WEBPACK_IMPORTED_MODULE_7__libs_util_js__["a" /* default */].formatTimestamp(this.model.settlementPeriod, "yyyy-MM");
            }
            if (this.bindWithRoute) {
                this.$router.push({
                    query: params
                });
            } else {
                this.fetchData(params);
            }
        },
        resetSearchForm: function resetSearchForm() {
            var _this = this;

            this.$refs.search.resetFields();
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.page, { page: 1 });
            this.$emit('reset');
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
                _this.submitSearchParams('reset');
            });
        },
        fetchData: function fetchData(params) {
            var _this2 = this;

            this.loading = true;
            this.$http.get(this.api + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params)).then(function (result) {
                _this2.loading = false;
                _this2.list = result.list;
                _this2.$emit('submitInquire', result);
                _this2.total = result.totalElements;
            }).catch(function (error) {
                _this2.list = [];
                _this2.loading = false;
                _this2.$Message.error("错误：" + error.message);
            });
        },
        exportExcel: function exportExcel(columns) {
            this.$refs.PagedList.$refs.table.exportCsv({
                filename: '配方列表',
                original: false,
                columns: columns,
                data: this.list.map(function (k) {
                    k.code = '\t' + k.code;
                    return k;
                })
            });
        }
    },
    computed: {
        newList: function newList() {
            var ret = this.list;
            if (this.responseFn) ret = this.responseFn(ret, this.total);
            return ret;
        }
    },
    components: {
        PagedList: __WEBPACK_IMPORTED_MODULE_6__PagedList___default.a
    }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function getUrl() {
  var apiUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//a1.easemob.com";
  var xmppUrl = "//im-api-v2.easemob.com/ws";
  if (window.location.href.indexOf("192.168.33.232") !== -1) {
    apiUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//a1.easemob.com";
    xmppUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//im-api-v2.easemob.com/ws";
  } else if (window.location.href.indexOf("192.168.13.54") !== -1) {
    apiUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//a1.easemob.com";
    xmppUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//im-api-v2.easemob.com/ws";
  } else if (window.location.href.indexOf("localhost") !== -1) {
    apiUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//a1.easemob.com";
    xmppUrl = (window.location.protocol === "https:" ? "https:" : "http:") + "//im-api-v2.easemob.com/ws";
  }
  return {
    apiUrl: apiUrl,
    xmppUrl: xmppUrl
  };
}

var config = {
  xmppURL: 'https://im-api-v2.easemob.com/ws',

  apiURL: 'https://a1.easemob.com',

  appkey: "1184170206115288#mingwo",

  Host: "easemob.com",

  https: true,
  isHttpDNS: true,

  isMultiLoginSessions: false,

  isWindowSDK: false,

  isSandBox: false,

  isDebug: true,

  isStropheLog: false,

  autoReconnectNumMax: 5,

  autoReconnectInterval: 2,

  isWebRTC: true,
  i18n: "us",

  isAutoLogin: true,

  p2pMessageCacheSize: 500,

  delivery: true,

  groupMessageCacheSize: 200,


  loglevel: "ERROR",

  enableLocalStorage: true
};
/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_http__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ModalForm__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ModalForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ModalForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ModalSelect__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ModalSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ModalSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GenericForm__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GenericForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_GenericForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SearchList__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SearchList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SearchList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_design_dist_styles_iview_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_view_design_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_view_design_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_index_less__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__theme_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_js_modal_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_js_modal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_js_modal_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_js_dropdown_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_js_dropdown_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_js_dropdown_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_js_tooltip_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bootstrap_js_tooltip_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bootstrap_js_tooltip_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_summernote__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_summernote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_summernote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_summernote_dist_lang_summernote_zh_CN_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_summernote_dist_lang_summernote_zh_CN_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_summernote_dist_lang_summernote_zh_CN_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_clipboard2__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__libs_webIM_WebIM__ = __webpack_require__(108);

























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__libs_http__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_view_design___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('Loading', __WEBPACK_IMPORTED_MODULE_6__components_Loading___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ModalForm', __WEBPACK_IMPORTED_MODULE_7__components_ModalForm___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ModalSelect', __WEBPACK_IMPORTED_MODULE_8__components_ModalSelect___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('GenericForm', __WEBPACK_IMPORTED_MODULE_9__components_GenericForm___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('SearchList', __WEBPACK_IMPORTED_MODULE_10__components_SearchList___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */],
    WebIM: __WEBPACK_IMPORTED_MODULE_21__libs_webIM_WebIM__["a" /* default */],
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var accountsChildrent = [{
  path: 'orderRecord',
  meta: {
    title: '订单记录',
    breadcrumb: true
  },
  component: {
    name: 'orderRecord',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '订单记录'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(688)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(687)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'orderCheck',
  meta: {
    title: '订单审核',
    breadcrumb: true
  },
  component: {
    name: 'orderCheck',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '订单审核'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(686)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(685)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'serviceAwardCheck',
  meta: {
    title: '服务奖结算核对',
    breadcrumb: true
  },
  component: {
    name: 'serviceAwardCheck',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '服务奖结算核对'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(690)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(689)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'userWithdrawAuth',
  meta: {
    title: '光明使者提现审核',
    breadcrumb: true
  },
  component: {
    name: 'userWithdrawAuth',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '光明使者提现审核'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(692)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(691)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'hubQuitApply',
  meta: {
    title: '中心清户',
    breadcrumb: true
  },
  component: {
    name: 'hubQuitApply',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '', meta: {
      title: '中心清户'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(684)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'hubAccountRecord',
  meta: {
    title: '中心账户记录',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'agentsAuth',
  meta: {
    title: '代理提现审核',
    breadcrumb: true
  },
  component: {
    name: 'agentsAuth',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '代理提现审核'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(677)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'agentsCheck',
  meta: {
    title: '代理结算核对',
    breadcrumb: true
  },
  component: {
    name: 'agentsCheck',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '代理结算核对'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(680)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(679)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'appUseRecord',
  meta: {
    title: '设备使用记录',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/accountsManagement',
  redirect: '/accountsManagement/orderRecord',
  meta: {
    title: "账务管理",
    breadcrumb: true
  },
  component: {
    name: 'accountsManagement',
    template: '<router-view></router-view>'
  },
  children: accountsChildrent
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var basic = [{
  path: 'shareMgt',
  meta: {
    title: '分享素材',
    breadcrumb: true
  },
  component: {
    name: 'shareMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '分享素材'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(696)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: '新增',
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: '编辑',
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'satisfactionRating',
  meta: {
    title: '满意度评价',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(693)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/basicSetting',
  redirect: '/basicSetting/satisfactionRating',
  meta: {
    title: "基础设置",
    breadcrumb: true
  },
  component: {
    name: 'basicSetting',
    template: '<router-view></router-view>'
  },
  children: basic
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/brandManagement',
  redirect: '/brandManagement/brandMgt',
  meta: {
    title: "供应商管理",
    breadcrumb: true
  },
  component: {
    name: 'brandManagement',
    template: '<router-view></router-view>'
  },
  children: [{
    path: 'brandMgt',
    meta: {
      title: '供应商管理',
      breadcrumb: true
    },
    component: {
      name: 'brandMgt',
      template: '<router-view></router-view>'
    },
    children: [{
      path: '',
      meta: {
        title: '供应商管理'
      },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(697)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var discount = [{
  path: 'couponManagement',
  meta: {
    title: '优惠券管理',
    breadcrumb: true
  },
  component: {
    name: 'couponManagement',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '', meta: {
      title: '优惠券管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(706)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'couponData',
    meta: {
      title: "数据",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(705)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'couponLssue',
  meta: {
    title: '优惠券发放',
    breadcrumb: true
  },
  component: {
    name: 'couponLssue',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '', meta: {
      title: '优惠券发放'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(704)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAddLssue',
    meta: {
      title: "新建发放",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(702)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'lssueRecord',
    meta: {
      title: "发放记录",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(701)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'userLssue',
    meta: {
      title: "用户发放",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(703)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'couponLssue',
    meta: {
      title: "发放管理",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(700)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'cashCard',
  meta: {
    title: '现金卡',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(699)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'cardActivation',
  meta: {
    title: '卡激活',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(698)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/discountManagement',
  redirect: '/discountManagement/couponManagement',
  meta: {
    title: "优惠管理",
    breadcrumb: true
  },
  component: {
    name: 'discountManagement',
    template: '<router-view></router-view>'
  },
  children: discount
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var goods = [{
  path: 'goodsMgt',
  meta: {
    title: '商品管理',
    breadcrumb: true
  },
  component: {
    name: 'goodsMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '商品管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'purchase',
    meta: {
      title: "限购活动",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'productGift',
    meta: {
      title: "赠品管理",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'rwllClassify',
  meta: {
    title: '视力调理分类',
    breadcrumb: true
  },
  component: {
    name: 'rwllClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '视力调理分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'yyslClassify',
  meta: {
    title: 'AI电商分类',
    breadcrumb: true
  },
  component: {
    name: 'yyslClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: 'AI电商分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'dqzgClassify',
  meta: {
    title: '向内调理分类',
    breadcrumb: true
  },
  component: {
    name: 'dqzgClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '向内调理分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'yhfwClassify',
  meta: {
    title: '眼部养护分类',
    breadcrumb: true
  },
  component: {
    name: 'yhfwClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '眼部养护分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'yxyyClassify',
  meta: {
    title: '视力防控分类',
    breadcrumb: true
  },
  component: {
    name: 'yxyyClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '视力防控分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'sltlClassify',
  meta: {
    title: '食疗调理分类',
    breadcrumb: true
  },
  component: {
    name: 'sltlClassify',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '食疗调理分类'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'setGoods',
    meta: {
      title: "绑定商品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'mwwdProduct',
  meta: {
    title: '云仓商品管理',
    breadcrumb: true
  },
  component: {
    name: 'mwwdProduct',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    meta: {
      title: '云仓商品管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'operating',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'productGroup',
    meta: {
      title: "打包产品",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'activationCode',
  meta: {
    title: '光明使者激活码',
    breadcrumb: true
  },
  component: {
    name: 'activationCode',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '光明使者激活码'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'actionPage',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'activateCodeList',
  meta: {
    title: '激活码列表',
    breadcrumb: true
  },
  component: {
    name: 'activateCodeList',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '激活码列表'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(709)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/goodsManagement',
  redirect: '/goodsManagement/goodsMgt',
  meta: {
    title: "商品管理",
    breadcrumb: true
  },
  component: {
    name: 'goodsManagement',
    template: '<router-view></router-view>'
  },
  children: goods
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  path: '/home',
  meta: {
    title: '主页',
    breadcrumb: false
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(674)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hubMgt = [{
  path: 'hubMgt',
  meta: {
    title: '中心管理',
    breadcrumb: true
  },
  component: {
    name: 'hubMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    meta: {
      title: '中心管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'refWecomDepartment',
    meta: {
      title: "关联企业微信",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'nutritionButlerList',
    meta: {
      title: "光明使者",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'accountRecords',
    meta: {
      title: "账户记录",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'device',
    meta: {
      title: "智能理疗设备",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'device',
  meta: {
    title: '智能理疗设备',
    breadcrumb: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/hubManagement',
  redirect: '/hubManagement/hubMgt',
  meta: {
    title: "中心管理",
    breadcrumb: true
  },
  component: {
    name: 'hubManagement',
    template: '<router-view></router-view>'
  },
  children: hubMgt
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orderMgt = [{
  path: 'orderMgt',
  meta: {
    title: '订单管理',
    breadcrumb: true
  },
  component: {
    name: 'orderMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '订单管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'orderShipping',
  meta: {
    title: '订单发货',
    breadcrumb: true
  },
  component: {
    name: 'orderShipping',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '订单发货'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'bookingForm',
  meta: {
    title: '预约单',
    breadcrumb: true
  },
  component: {
    name: 'bookingForm',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '预约单'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'mwwdOrderMgt',
  meta: {
    title: '云仓订单管理',
    breadcrumb: true
  },
  component: {
    name: 'mwwdOrderMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '云仓订单管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(743)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新建",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(742)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'mwwdOrderSend',
  meta: {
    title: '云仓订单发货',
    breadcrumb: true
  },
  component: {
    name: 'mwwdOrderSend',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '云仓订单发货'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(744)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'planActivateMgt',
  meta: {
    title: '方案激活管理',
    breadcrumb: true
  },
  component: {
    name: 'planActivateMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '方案激活管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/orderManagement',
  redirect: '/orderManagement/orderMgt',
  meta: {
    title: "订单管理",
    breadcrumb: true
  },
  component: {
    name: 'orderManagement',
    template: '<router-view></router-view>'
  },
  children: orderMgt
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var promotion = [{
  path: 'group',
  meta: {
    title: '福利号活动',
    breadcrumb: true
  },
  component: {
    name: 'group',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    meta: {
      title: '福利号活动'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(764)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(763)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(762)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/editImage',
    meta: {
      title: "编辑附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(759)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/editGenie',
    meta: {
      title: "编辑附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(758)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/editMiniApp',
    meta: {
      title: "编辑附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(760)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/createMiniApp',
    meta: {
      title: "新建附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(757)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/createImage',
    meta: {
      title: "新建附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(756)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/createGenie',
    meta: {
      title: "新建附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(755)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment',
    meta: {
      title: "活动附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(761)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'friend',
  meta: {
    title: '朋友圈活动',
    breadcrumb: true
  },
  component: {
    name: 'friend',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    meta: {
      title: '朋友圈活动'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(754)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(753)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(752)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/editImage',
    meta: {
      title: "编辑附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment/createImage',
    meta: {
      title: "新建附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'attachment',
    meta: {
      title: "活动附件",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/promotion',
  redirect: '/promotion/promotion',
  meta: {
    title: "私域运营",
    breadcrumb: true
  },
  component: {
    name: 'promotion',
    template: '<router-view></router-view>'
  },
  children: promotion
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var agents = [{
  path: 'agentsList',
  meta: {
    title: '代理列表',
    breadcrumb: true
  },
  component: {
    name: 'agentsList',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(766)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'newAdd',
    meta: {
      title: "新增代理",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(767)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'editor',
    meta: {
      title: "编辑代理",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(765)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'userInformation',
    meta: {
      title: "用户信息",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(768)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'agentsWithdraw',
  meta: {
    title: '代理提现',
    breadcrumb: true
  },
  component: {
    name: 'agentsWithdraw',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(772)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "代理提现详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(771)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'agentsSettlement',
  meta: {
    title: '代理结算',
    breadcrumb: true
  },
  component: {
    name: 'agentsSettlement',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '/',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(770)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: "代理结算详情",
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(769)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/provinceCityAgents',
  redirect: '/provinceCityAgents/agentsList',
  meta: {
    title: "省市代理",
    breadcrumb: true
  },
  component: {
    name: 'provinceCityAgents',
    template: '<router-view></router-view>'
  },
  children: agents
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setting__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userCenter__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__promotion__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brandManagement__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__goodsManagement__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__discount__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orderManagement__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accountsManagement__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__basicSetting__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hubManagement__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__provinceCityAgents__ = __webpack_require__(341);













var indexRoute = {
    path: '/',
    name: 'index',
    meta: {
        title: "首页",
        breadcrumb: true
    },
    redirect: {
        name: 'home'
    },
    component: function component(resolve) {
        __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(675)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [__WEBPACK_IMPORTED_MODULE_0__setting__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__userCenter__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__brandManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__goodsManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__discount__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__orderManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__accountsManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__basicSetting__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__hubManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__provinceCityAgents__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__promotion__["a" /* default */]]
};

var loginRoute = {
    name: 'login',
    path: '/login',
    meta: {
        title: "登录",
        breadcrumb: true
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(676)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ([indexRoute, loginRoute]);

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var resource = {
    path: 'resource',
    meta: {
        title: "资源管理",
        breadcrumb: true
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(780)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
};

var role = {
    path: 'role',
    meta: {
        title: "角色管理",
        breadcrumb: true
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
};

var user = {
    path: 'user',
    meta: {
        title: "用户管理",
        breadcrumb: true
    },
    component: {
        name: 'UserManager',
        template: '<router-view></router-view>'
    },
    children: [{
        path: '',
        meta: {
            title: "用户管理"
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: 'create',
        meta: {
            title: "添加用户",
            breadcrumb: false
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: ':user_id',
        meta: {
            title: "编辑用户资料",
            breadcrumb: false
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
};

var organization = {
    path: 'organization',
    meta: {
        title: "组织机构",
        breadcrumb: true
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(779)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/setting',
    redirect: '/setting/user',
    meta: {
        title: "系统设置",
        breadcrumb: true
    },
    component: {
        name: 'setting',
        template: '<router-view></router-view>'
    },
    children: [resource, role, user, organization]
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var userMgt = [{
  path: 'userMgt',
  meta: {
    title: '用户管理',
    breadcrumb: true
  },
  component: {
    name: 'userMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '用户管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(776)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'guangmingMgt',
  meta: {
    title: '光明使者管理',
    breadcrumb: true
  },
  component: {
    name: 'guangmingMgt',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '光明使者管理'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'userSettle',
  meta: {
    title: '光明使者结算',
    breadcrumb: true
  },
  component: {
    name: 'userSettle',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '光明使者结算'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(778)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: '详情',
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(777)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: 'userExtract',
  meta: {
    title: '光明使者提现',
    breadcrumb: true
  },
  component: {
    name: 'userExtract',
    template: '<router-view></router-view>'
  },
  children: [{
    path: '',
    meta: {
      title: '光明使者提现'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(775)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'detail',
    meta: {
      title: '详情',
      breadcrumb: true
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/userCenter',
  redirect: '/userCenter/userMgt',
  meta: {
    title: "用户管理",
    breadcrumb: true
  },
  component: {
    name: 'userCenter',
    template: '<router-view></router-view>'
  },
  children: userMgt
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_webIM_WebIM__ = __webpack_require__(108);



var _mutations;


var mutationsTypes = {
	SHOW_MULTIANMODAL: "SHOW_MULTIANMODAL",
	HIDE_MULTIANMODAL: "HIDE_MULTIANMODAL",
	SET_CONFR: "SET_CONFR",
	SET_AVMEMBERMODAL_VISIBLE: "SET_AVMEMBERMODAL_VISIBLE",
	SET_EXPERT_STATUS: "SET_EXPERT_STATUS"
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: {
		msgStatus: {},
		multiAVModalVisible: false,
		confr: {},
		addAVMemberModalVisible: false,
		expertStatus: null
	},
	mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationsTypes.SHOW_MULTIANMODAL, function (state) {
		state.multiAVModalVisible = true;
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationsTypes.HIDE_MULTIANMODAL, function (state) {
		state.multiAVModalVisible = false;
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationsTypes.SET_CONFR, function (state, payload) {
		state.confr = payload.confr;
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationsTypes.SET_AVMEMBERMODAL_VISIBLE, function (state, payload) {
		state.addAVMemberModalVisible = payload.addAVMemberModalVisible;
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, mutationsTypes.SET_EXPERT_STATUS, function (state, payload) {
		state.expertStatus = payload.expertStatus;
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "updateMsgList", function updateMsgList(state, payload) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "updateMessageMid", function updateMessageMid(state, message) {
		state.msgStatus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, message);
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "updateMessageStatus", function updateMessageStatus(state, message) {}), _mutations),
	actions: {
		showMultiAVModal: function showMultiAVModal(context) {
			context.commit(mutationsTypes.SHOW_MULTIANMODAL);
		},
		hideMultiAVModal: function hideMultiAVModal(context) {
			context.commit(mutationsTypes.HIDE_MULTIANMODAL);
		},
		setConfr: function setConfr(context, payload) {
			context.commit({
				type: mutationsTypes.SET_CONFR,
				confr: payload.confr
			});
		},
		setAVMemeberModalVisible: function setAVMemeberModalVisible(context, payload) {
			context.commit({
				type: mutationsTypes.SET_AVMEMBERMODAL_VISIBLE,
				addAVMemberModalVisible: payload.addAVMemberModalVisible
			});
		},
		setExpertStatus: function setExpertStatus(context, payload) {
			context.commit({
				type: mutationsTypes.SET_EXPERT_STATUS,
				expertStatus: payload.expertStatus
			});
		}
	},
	getters: {}
});

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Input', {
    attrs: {
      "value": _vm.value,
      "readonly": "",
      "placeholder": _vm.title,
      "icon": "edit"
    },
    on: {
      "click": _vm.showModal,
      "on-click": _vm.showModal,
      "on-focus": _vm.showModal
    }
  }), _vm._v(" "), (_vm.enable) ? _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "960"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "inline": true,
      "label-width": 120
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('Row', [_vm._t("default", function() {
    return [_vm._v("此处为查询条件")]
  }, {
    "model": _vm.model
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("查询")])], 1)], 2)], 1), _vm._v(" "), _c('PagedList', {
    attrs: {
      "loading": _vm.loading,
      "page": _vm.page,
      "columns": _vm.columns,
      "list": _vm.list,
      "total": _vm.total
    },
    on: {
      "changePage": _vm.changePage,
      "dblclickRow": _vm.dblclickRow
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enable) ? _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": _vm.modeWidth
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default", function() {
    return [_vm._v("请在此设计表单")]
  }, {
    "model": _vm.model
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("用于使表单支持enter提交")])])], 2), _vm._v(" "), (_vm.showFooterBtn) ? _c('div', {
    style: (_vm.textStyle),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.form.resetFields()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    style: (_vm.floatDom)
  }, [_vm._t("actions")], 2)]), _vm._v(" "), (_vm.modalWrap) ? _c('Form', {
    ref: "search",
    attrs: {
      "model": _vm.model,
      "inline": true,
      "label-width": 120
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('Row', [(_vm.modalWrap) ? _vm._t("default", function() {
    return [_vm._v("此处为查询条件")]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.showQueryBtn) ? _c('Button', {
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("查询")]) : _vm._e(), _vm._v(" "), (_vm.showReseBtn) ? _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_vm._v("清空")]) : _vm._e()], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('div', {}, [_vm._t("bottomActions")], 2)]), _vm._v(" "), _c('PagedList', {
    ref: "PagedList",
    attrs: {
      "pageFloat": _vm.pageFloat,
      "pageSize": _vm.pageSize,
      "stripe": _vm.stripe,
      "loading": _vm.loading,
      "page": _vm.page,
      "columns": _vm.columns,
      "highlight": _vm.highlight,
      "showHeader": _vm.showHeader,
      "pageList": _vm.pageList,
      "list": _vm.newList,
      "total": _vm.total
    },
    on: {
      "changePage": _vm.changePage,
      "changeSelection": _vm.onChangeSelection,
      "clickRow": _vm.onclickRow,
      "onSortCange": _vm.onSortCange
    }
  }, [_c('div', {
    attrs: {
      "slot": "footerData"
    },
    slot: "footerData"
  }, [_vm._t("bottomFooter")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.heights)
  }, [(!_vm._loading) ? _c('div', [_vm._t("default")], 2) : _c('div', {
    staticClass: "container"
  }, [_vm._t("spin", function() {
    return [_c('Spin', {
      attrs: {
        "fix": ""
      }
    }, [_c('Icon', {
      staticClass: "demo-spin-icon-load",
      attrs: {
        "type": "ios-loading",
        "size": "40"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v("加载中")])], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paged-list"
  }, [_c('Table', {
    ref: "table",
    staticClass: "list",
    attrs: {
      "stripe": _vm.stripe,
      "border": "",
      "columns": _vm.columns,
      "data": _vm.list,
      "highlight-row": _vm.highlight,
      "show-header": _vm.showHeader,
      "loading": _vm.loading
    },
    on: {
      "on-selection-change": _vm.onChangeSelection,
      "on-row-click": _vm.onclickRow,
      "on-sort-change": _vm.sortCange
    }
  }, [_c('div', {
    staticClass: "spin-container",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "spin-icon-load",
    attrs: {
      "type": "ios-loading",
      "size": "48"
    }
  })], 1)], 1), _vm._v(" "), (_vm.footerShow) ? _c('div', {
    staticClass: "spin-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("footerData")], 2) : _vm._e()]), _vm._v(" "), (_vm.pageList) ? _c('div', {
    style: (_vm.pageFloat)
  }, [_c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.total,
      "current": _vm.page.page,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": "",
      "page-size-opts": _vm.pageSize
    },
    on: {
      "on-change": _vm.onChangePage,
      "on-page-size-change": _vm.onChangePageSize
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitEditForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default", function() {
    return [_vm._v("请在此设计表单")]
  }, {
    "model": _vm.model
  }), _vm._v(" "), _c('FormItem', [(_vm.resetShow) ? _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.$refs.form.resetFields();
        _vm.$emit('reset')
      }
    }
  }, [_vm._v("重置")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditForm
    }
  }, [_vm._v(_vm._s(_vm.submitBtnTxt))]), _vm._v(" "), _vm._t("btn")], 2)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[331]);


// WEBPACK FOOTER //
// static/js/app.31baf85da7bb52678021.js